import React from 'react';

import { FaIcon } from '@innovationnorway/component-library';
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import { useTranslation } from 'react-i18next';
import ActionPageDescription from '../ActionPageDescription';

const CommunicationBetweenActors: React.FC = () => {
  const { t: tCommon } = useTranslation();
  const { t: tOneWayIn } = useTranslation('oneWayIn');
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  return (
    <>
      <h3 className="margin-bottom--6">
        {tHelpAndSupport('commonQuestions.Interplay.CommunicationBetweenActors')}
      </h3>
      <div className="display--flex flex-direction--column gap--6">
        <ActionPageDescription
          icon={<FaIcon icon={findIconDefinition({ prefix: 'fas', iconName: 'paper-plane' })} />}
          iconName={tOneWayIn('details.Title.Referrer')}
          description={tHelpAndSupport('commonQuestions.CommunicationBetweenActors.ReferrerDescription')}
        />
        <ActionPageDescription
          icon={<FaIcon icon={findIconDefinition({ prefix: 'fal', iconName: 'note-sticky' })} />}
          iconName={tCommon('note')}
          description={tHelpAndSupport('commonQuestions.CommunicationBetweenActors.NoteDescription')}
        />
        <ActionPageDescription
          icon={<FaIcon icon={findIconDefinition({ prefix: 'fal', iconName: 'list-timeline' })} />}
          iconName={tOneWayIn('details.Title.ActivityLog')}
          description={tHelpAndSupport('commonQuestions.CommunicationBetweenActors.ActivityLogDescription')}
        />
        <ActionPageDescription
          icon={<FaIcon icon={findIconDefinition({ prefix: 'fal', iconName: 'box-archive' })} />}
          iconName={tOneWayIn('details.Title.Archiving')}
          description={tHelpAndSupport('commonQuestions.CommunicationBetweenActors.ArchivingDescription')}
        />
      </div>
    </>
  );
};

export default CommunicationBetweenActors;
